


import React , {useState,useEffect, useRef, useContext } from 'react'
import {Link,useParams,useLocation} from 'react-router-dom'
import '../../../styles/devotionalVideo.css'
import '../../../styles/devotionalVideos.css'
import { FaFacebook } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import he from 'he'
import Skeleton from '../../pages/skelton.jsx';
import DevotionalBreadCrumb from '../devotionalBreadCrumb';
import MoreRelated from './moreRelated';
import { Helmet } from 'react-helmet-async';
import PageAds from '../../common/pageAds.jsx';
import { DeviceContext } from '../index.jsx';




const DevotionalVideo = ({data}) => {
                         const location = useLocation().pathname;
                         const { content } = useParams();
                         const hydratedRef = useRef(false);

                        //  Extract contentId and subCat from URL param
                        const contentId = content?.substring(content.lastIndexOf('-') + 1, content.lastIndexOf('.html'));
                        const cutUrl = content?.substring(0, content.lastIndexOf('-'));
                        const subCat = cutUrl?.substring(cutUrl.lastIndexOf('-') + 1);

                        // SSR Data
                        const ssrData = data?.[0]?.videoSinglePage?.videoSinglePageData || null;
                        const ssrSingleArticle = ssrData?.devotional_single?.[0] || null;
                        const ssrPrevArticle = ssrData?.prvartcile || null;
                        const ssrNxtArticle = ssrData?.nxtarticle || null;
                        const ssrRelArticle = ssrData?.relarticle || null;
                        const ssrContentId = data?.[0]?.videoSinglePage?.contentId; 

                        // State
                        const [singleArticle, setSingleArticle] = useState( ssrSingleArticle);
                        const [prevArticle, setPrevArticle] = useState( ssrPrevArticle);
                        const [nxtArticle, setNxtArticle] = useState(ssrNxtArticle);
                        const [relarticle, setRelArticle] = useState( ssrRelArticle);
                        const [loading, setLoading] = useState(ssrContentId !== contentId);
                        const [error, setError] = useState(null);
                         const {mobile,setMobile,containerRef} = useContext(DeviceContext)
                        const [adJson ,setAdJson] = useState(null)

  useEffect(() => {
        fetch("https://www.teluguone.com/teluguone-ssr-server/ad.php")
         .then(res => res.json())
         .then(data => setAdJson(data))
         .catch(err => console.error(err));
       }, []);






useEffect(() => {
  // Skip fetch only on first SSR hydration
  if (
    !hydratedRef.current &&
    String(ssrContentId) === String(contentId) && ssrData
  ) {
    hydratedRef.current = true;
    setLoading(false);
    setError(null);
    return;
  }

  hydratedRef.current = true;

  let cancelled = false;

  const getData = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(
        `https://www.teluguone.com/devotional_api/devotionalSingleVideoJson?subCat=${subCat}&contentId=${contentId}`
      );

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const json = await res.json();

      if (cancelled) return;

      setSingleArticle(
        json?.devotional_single?.devotional_single?.[0] || null
      );

      setPrevArticle(
        json?.devotional_single?.prvartcile || null
      );

      setNxtArticle(
        json?.devotional_single?.nxtarticle || null
      );

      setRelArticle(
        json?.devotional_single?.relarticle || null
      );

      setLoading(false);
    } catch (err) {
      if (cancelled) return;

      setSingleArticle(null);
      setPrevArticle(null);
      setNxtArticle(null);
      setRelArticle(null);
      setError(err.message);
      setLoading(false);
    }
  };

  getData();

  return () => {
    cancelled = true;
  };
}, [contentId, subCat]);
                        


                      

                      if (loading ) {

                      return (    
                          <div className="w-100 d-flex flex-wrap">
                          <div className='devotional-video-page'>
                                          <div className='container-fluid'>
                                              <div className='row mt-5'>
                                                  <div className='col-12'><Skeleton type={"title"} /></div>
                                                  <div className='col-4'><Skeleton type={"paragraph"} /></div>
                                                  <div className='col-12 d-flex justify-content-center'><Skeleton type={"big-square"} /></div>
                                                  <div className='col-12 d-flex justify-content-center'><Skeleton type={"paragraph"} /></div>
                                                
                                              </div>
                                                 <div className='row g-0'>
                                                          {Array(8).fill("o").map((_,index) =>
                                                              <div key={index} className="col-6 col-sm-4 col-md-3">
                                                                     <Skeleton type={"square"} />
                                                                     <Skeleton type={"title"} />
                                                             </div>
                                                         ) }
                                                    </div> 
                                          </div>
                                      </div>
                        

                          </div> 

                      )
                      }


                      if (error) {
                      return (
                        <div className='devotional-video-page'>
                          <div className="json-loading-error-div mt-2">
                          <img  src="/devotional/assets/images/json_error.png" alt="json_error" />
                          </div>
                        </div>
                      )
                      }
                            


                  function isTelugu(text) {

                       const teluguRegex = /[\u0C00-\u0C7F]/;
                       return teluguRegex.test(text);
                       
                     }         


                    return (
                                <div className='devotional-video-page'>
                                <Helmet> <title> {(singleArticle?.video_title || "Devotional Video") +  " | Telugu Devotional Video | TeluguOne"} </title>
</Helmet>
                                   <DevotionalBreadCrumb breadCrumb={singleArticle?.vcat_name} />
                                  <div className='container-fluid g-0'>
                                      <div className='row g-0'>
                                        <div className='col-12 video-title' >{singleArticle?.video_title}</div>

                                      <div className='col-12'>
                                         <div className="devotional-content-main-box">
                                         <div className='devotional-video-player'>
                                              <iframe width="100%" height="100%" src={singleArticle?.video_url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                                        </div>
                                         </div>
                                      </div>
                      
                                      <div className='col-12 d-flex justify-content-end'>
                                        <Link to={`https://www.facebook.com/sharer.php?u=https://www.teluguone.com${location}`} className='devotional-content-share-anchor' ><FaFacebook className='devotional-content-share-icon devotional-content-fb-icon' /></Link>
                                        <Link to={`https://twitter.com/share?url=https://www.teluguone.com${location}`} className='devotional-content-share-anchor'> <FaSquareXTwitter  className='devotional-content-share-icon devotional-content-x-icon' /></Link>
                                      </div>

                                         <div className='col-12 m-3'> 
                                  
                                        <center>      
                                        {adJson && adJson.googleNewsAd?.link ? <a href={adJson?.googleNewsAd?.link} target="_blank" rel="noreferrer">
                                                                                   <img src={adJson?.googleNewsAd?.img} alt="google-ad-img" />
                                                                                   </a>
                                                                                   :
                                                                                   <a href="https://news.google.com/search?q=site:teluguone.com&hl=te&gl=IN&ceid=IN:te" target="_blank" rel="noreferrer">
                                                                                          <img src=" https://www.teluguone.com/images/g-news-banner.gif" alt="google-ad-img" />
                                                                                    </a>
                                                                                   
                                                                                   } 
                                        </center>


                                     </div>
                             </div> 
                                 <div className='row g-0 mb-3'> 


                                   { Array.isArray(prevArticle)  ? (
                                 <div className='col-6 d-flex justify-content-start'>
                                 <div className="devotional-content-prev-next-box me-auto">
                                <Link to={prevArticle?.[0].pr_url.substring(prevArticle?.[0].pr_url.indexOf("/devotional")+11)} style={{textDecoration:"none"}}> 
                                <div className="card devotional-content-prev-next-box-card me-auto">
                              <img src={prevArticle[0].pr_image ? prevArticle[0].pr_image : '/devotional/assets/images/error_img.webp'} alt="prev-img" />
                              <div className="devotional-content-card-img-overlay">
                                  <h5 className="card-title devotional-content-prev-next-title devotional-content-prev">{'← Prev'}</h5>
                                  <p className="card-text devotional-content-prev-next-heading lh-small" 
                                    style={
                                        !isTelugu(prevArticle?.[0].pr_title ? he.decode(prevArticle[0].pr_title ) : "prevTitle" )
                                          ? {
                                              fontFamily:
                                                "'Segoe UI', system-ui, -apple-system, 'Noto Sans Telugu', Roboto, Arial, sans-serif"
                                            }
                                          : {}
                                      }
                                   dangerouslySetInnerHTML={{ __html:prevArticle?.[0].pr_title ? he.decode(prevArticle[0].pr_title) : "prevTitle" }}></p>
                              </div>

                            </div>
                                </Link>
                                 </div>
                                  </div>
                                    ) : <div className='col-6'></div>} 

                                  { Array.isArray(nxtArticle)  ?
                                  (
                                    <div className='col-6 d-flex justify-content-end'>
                                      <div className="devotional-content-prev-next-box ms-auto">
                                        <Link to={nxtArticle?.[0].nxt_url.substring(nxtArticle?.[0].nxt_url.indexOf("/devotional")+11)} style={{textDecoration:"none"}}> 
                                        <div className="card devotional-content-prev-next-box-card">
                                      <img src={nxtArticle?.[0].nxt_image ? nxtArticle?.[0].nxt_image : '/devotional/assets/images/error_img.webp'} alt="next-img" />
                                      <div className="devotional-content-card-img-overlay">
                                          <h5 className="card-title text-end devotional-content-prev-next-title devotional-content-next ms-auto">{'Next →'}</h5>
                                          <p className="card-text text-end devotional-content-prev-next-heading lh-small" 
                                     
                                           style={
                                               !isTelugu(nxtArticle?.[0].nxt_title ? he.decode(nxtArticle[0].nxt_title) : 'Title' )
                                                      ? {
                                                         fontFamily:
                                                            "'Segoe UI', system-ui, -apple-system, 'Noto Sans Telugu', Roboto, Arial, sans-serif"
                                                        }
                                                     : {}
                                                    }

                                           dangerouslySetInnerHTML={{ __html: nxtArticle?.[0].nxt_title ? he.decode(nxtArticle[0].nxt_title) : 'Title' }}></p>
                                      </div>

                                    </div>
                                        </Link>
                                  </div>
                                  </div>   
                                  ) :  <div className='col-6'></div>
                                  }

                                </div>

                                <MoreRelated item={relarticle} subCat={subCat} />

                                  </div>
                                 <PageAds mobile={mobile} containerRef={containerRef} />
                              </div>
                    )
                  }

                  export default DevotionalVideo;


